export interface StatItem {
  value: string;
  label: string;
  icon: string;
}

export interface TestimonialItem {
  name: string;
  role: string;
  avatar: string;
  content: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export interface PrincipleItem {
  title: string;
  desc: string;
  icon: string;
}

export const hotKeywords = [
  '食堂新窗口',
  '选课系统崩溃',
  '宿舍楼下橘猫',
  '天台毕业告白',
  '社团招新现场',
  '期末周通宵',
  '军训才艺表演',
  '校园二手市集',
  '图书馆占座新规',
];

export const stats: StatItem[] = [
  { value: '2,480+', label: '累计收录校园事件', icon: 'ri-article-line' },
  { value: '186', label: '覆盖高校与校区', icon: 'ri-building-2-line' },
  { value: '12.6万', label: '累计围观人次', icon: 'ri-eye-line' },
  { value: '3,900+', label: '同学投稿爆料', icon: 'ri-send-plane-line' },
];

export const testimonials: TestimonialItem[] = [
  {
    name: '林知遥',
    role: '大三 · 云栖大学',
    avatar:
      'https://readdy.ai/api/search-image?query=warm%20friendly%20portrait%20of%20a%20young%20chinese%20female%20university%20student%20smiling%20softly%2C%20warm%20natural%20light%2C%20cream%20background%2C%20editorial%20headshot%2C%20coral%20amber%20tones%2C%20no%20text&width=200&height=200&seq=avatar-student-01&orientation=squarish',
    content:
      '以前刷到校园热点，前后经过全断片。这里会把时间线一条条摆出来，看完整件事再说话，安心很多。',
  },
  {
    name: '周砚',
    role: '大四 · 江城理工大学',
    avatar:
      'https://readdy.ai/api/search-image?query=warm%20friendly%20portrait%20of%20a%20young%20chinese%20male%20university%20student%20with%20glasses%2C%20gentle%20smile%2C%20warm%20natural%20light%2C%20cream%20background%2C%20editorial%20headshot%2C%20coral%20amber%20tones%2C%20no%20text&width=200&height=200&seq=avatar-student-02&orientation=squarish',
    content:
      '分类做得很清楚，想找学业相关的就点学业，不用在信息流里翻半天。投稿入口也顺手，两分钟就交上去了。',
  },
  {
    name: '陈屿安',
    role: '大二 · 临海师范大学',
    avatar:
      'https://readdy.ai/api/search-image?query=warm%20friendly%20portrait%20of%20a%20young%20chinese%20female%20university%20student%20with%20short%20hair%2C%20calm%20confident%20expression%2C%20warm%20natural%20light%2C%20cream%20background%2C%20editorial%20headshot%2C%20coral%20amber%20tones%2C%20no%20text&width=200&height=200&seq=avatar-student-03&orientation=squarish',
    content:
      '最喜欢的一点是没有情绪化标题，就事论事。看学校的新规，能看到支持和不支持两边的说法。',
  },
  {
    name: '许南',
    role: '大一 · 白鹭大学',
    avatar:
      'https://readdy.ai/api/search-image?query=warm%20friendly%20portrait%20of%20a%20young%20chinese%20male%20university%20student%20with%20a%20cap%2C%20cheerful%20smile%2C%20warm%20natural%20light%2C%20cream%20background%2C%20editorial%20headshot%2C%20coral%20amber%20tones%2C%20no%20text&width=200&height=200&seq=avatar-student-04&orientation=squarish',
    content:
      '刚入学什么都不懂，尤其是选课和社团。翻了几天这里的合集，感觉提前上了一堂「校园生活预习课」。',
  },
];

export const faqs: FaqItem[] = [
  {
    question: '「高校吃瓜」主要收录哪些内容？',
    answer:
      '我们聚焦校园公共话题，包括校园生活、学业考场、社团活动、宿舍日常、校园美食、情感小站与实习求职等方向。所有事件都会整理公开信息与同学投稿中的可核实部分，并附上一条清晰的时间线。',
  },
  {
    question: '网站上的校园名称和人物信息是真的吗？',
    answer:
      '为保护当事人隐私，站内涉及的校园名称均做了模糊化处理，也不会公布任何真实姓名、联系方式或可定位到个人的信息。我们只讨论事件本身与公共议题，不做人身指向。',
  },
  {
    question: '我看到的事件有后续，怎么告诉你们？',
    answer:
      '可以通过页面上的「爆料投稿」入口提交。请在内容里尽量写明时间、地点、事情经过和你希望补充的信息，我们会核对后更新到对应事件的时间线中。',
  },
  {
    question: '投稿后多久会有反馈？',
    answer:
      '一般会在三个工作日内完成初步核对。如果信息完整且可以交叉确认，我们会尽快更新；如果需要补充材料，会通过你填写的联系方式与你沟通。',
  },
  {
    question: '内容会不会带有明显的倾向性？',
    answer:
      '我们希望尽量呈现事实与多方说法。对于存在不同观点的话题（例如校园新规），会同时列出支持与保留的意见，让读者自己判断，而不是替读者下结论。',
  },
  {
    question: '可以转载站内内容吗？',
    answer:
      '欢迎在注明来源与原文链接的前提下合理引用。请不要对标题与正文做断章取义的改动，也不要用于任何针对个人的传播。',
  },
];

export const principles: PrincipleItem[] = [
  {
    title: '就事论事',
    desc: '只讨论公共事件与校园议题，不针对任何真实个人，不做人身评价。',
    icon: 'ri-scales-3-line',
  },
  {
    title: '来源可溯',
    desc: '每条信息都标注可核实的出处与时间，无法确认的内容宁可暂不发布。',
    icon: 'ri-file-search-line',
  },
  {
    title: '多方视角',
    desc: '同一件事尽量呈现不同立场的声音，让读者看到全貌而不是一面之词。',
    icon: 'ri-chat-voice-line',
  },
  {
    title: '保护隐私',
    desc: '模糊化校园与个人信息，不公开任何可定位到具体个人的细节。',
    icon: 'ri-shield-check-line',
  },
];

export const submissionTips = [
  '写清事件发生的大致时间与场景，越具体越有帮助',
  '附上可公开的图片或链接，方便我们交叉核对',
  '说明你希望补充的是哪一部分信息或后续进展',
  '如果涉及他人隐私，请先做模糊处理再提交',
];